module.exports = __webpack_public_path__ + "createstatic/media/Button-choose.d470b42e.svg";